import Grid from "@mui/material/Grid";
import React, { useContext, useEffect, useState } from "react";
import Notes from "../../CallInfo/Notes";
import MonitoringCallInfoBody from "./MonitoringCallInfoBody";
import { Theme } from '@mui/material/styles';
import { MsalContext } from "../../Contexts/MsalContext";
import Box from "@mui/material/Box";
import NuisanceCall from "../../CallInfo/NuisanceCall";
import MonitoringCallIndexContainer from "./MonitoringCallIndexContainer";

const styles = {
    scroll: {
        backgroundColor: '#fff',
        height: '100%',
        overflowY: 'auto',
        padding: (theme: Theme) => theme.spacing(1),
    }
}

interface ICallDetailTabProps {
    id: string | null
    setId: (newId: string) => void;
    agentView?: boolean;
    systemId: string;
}

export default function CallDetailsTab(props: ICallDetailTabProps) {
    const { msalFetch } = useContext(MsalContext);
    const [callData, setCallData] = useState<any>(null);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [isRTM, setIsRTM] = useState<boolean>(false);
    const [isClient, setIsClient] = useState<boolean>(false);

    useEffect(() => {
        fetchData();
    }, []);

    const checkIfRTM = () => {
        msalFetch('api/User/IsRTM')
            .then(response => response.json())
            .then(data => {
                setIsRTM(data);
            });
    }

    const checkIfClient = () => {
        msalFetch('api/User/IsClient')
            .then(response => response.json())
            .then(data => {
                setIsClient(data);
            });
    }

    const fetchData = () => {
        checkIfRTM();
        checkIfClient();
        msalFetch('api/Info/GetInfo?systemPk=' + encodeURIComponent(props.id!))
            .then(response => response.json())
            .then(Data => {
                setCallData(Data);
                setLoaded(true);
            });
    };

    return (
        <Box sx={styles.scroll}>
            {loaded && props.id !== null &&
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <MonitoringCallInfoBody id={props.id} systemId={props.systemId} />
                    </Grid>
                    <Grid size={12}>
                        {
                            isRTM === true && callData.result === 'NC' && isClient === false &&
                            <Grid size={12}>
                                <NuisanceCall systemPK={props.id} />
                            </Grid>
                        }
                        <MonitoringCallIndexContainer
                            callId={props.id}
                            customerId={callData.customerID}
                            setId={props.setId}
                            callSwitchEnabled={!props.agentView}
                        />
                    </Grid>
                    {
                        !props.agentView &&
                        <Grid size={12}>
                            <Notes systemPK={props.id} monitoring={true} />
                        </Grid>
                    }
                </Grid >
            }
        </Box >
    );
}